"use client"

import styled from "@emotion/styled"
import { MenuItem, Select } from "@mui/material"

type Props = {
  field: any
  options: any
}

const StyledMenuItem = styled(MenuItem)`
  height: 45px !important;
  padding-left: 16px !important;
  padding-right: 16px !important;
`

const SelectCustom = ({ field, options }: Props) => {
  return (
    <Select
      labelId="preferred-work-region-label"
      {...field}
      MenuProps={{
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left",
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "left",
        },
      }}
    >
      {options.map((option: any) => {
        return (
          <StyledMenuItem value={option.value}>{option.label}</StyledMenuItem>
        )
      })}
    </Select>
  )
}

export default SelectCustom
